export function Loading({ label = "Loading the archive" }) {
  return (
    <div className="loading-state" role="status">
      <span className="loading-state__line" />
      <span>{label}</span>
    </div>
  );
}

export function ErrorMessage({ children }) {
  return <p className="error-message" role="alert">{children}</p>;
}
